import Menus from './menus'

export default Menus
